import { v4 as uuidv4 } from 'uuid'

export const routes = [...new Array(5)].map((_: any, index: number) => ({
  id: uuidv4(),
  name: 'Routes Code ' + ++index,
  __typename: 'Route'
}))
